// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"199":"c78bf87e","356":"1ef60f76","436":"f36991c6","448":"8e0d372d","591":"4ace98e6","675":"30713354"}[chunkId] + ".chunk.css";
};